import { forwardRef } from "react";
import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Icon } from "../icons";
import type { IconName } from "../icons";

export type ButtonKind = "icon" | "text" | "ghost" | "primary" | "danger";

export type ButtonSize = "sm" | "md" | "lg";

export type ButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  label: string;
  kind?: ButtonKind;
  size?: ButtonSize;
  icon?: IconName | null;
  trailingIcon?: IconName | null;
  pressed?: boolean | null;
  busy?: boolean;
  children?: ReactNode;
  action?: string;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button({ label, kind = "icon", size = "md", icon = null, trailingIcon = null, pressed = null, busy = false, className, children, action, title, type = "button", disabled, ...rest }, ref) {
  const iconOnly = kind === "icon";
  const classes = ["fxmap-btn", `fxmap-btn-${kind}`, size !== "md" ? `fxmap-btn-${size}` : "", busy ? "fxmap-btn-busy" : "", className ?? ""].filter(Boolean).join(" ");

  return (
    <button
      {...rest}
      ref={ref}
      type={type}
      className={classes}
      aria-label={iconOnly ? label : rest["aria-label"]}
      aria-pressed={pressed === null ? undefined : pressed}
      aria-busy={busy || undefined}
      title={title ?? (iconOnly ? label : undefined)}
      disabled={disabled || busy}
      data-fxmap-action={action}
    >
      {icon !== null ? <Icon name={icon} /> : null}
      {iconOnly ? null : <span className="fxmap-btn-label">{children ?? label}</span>}
      {trailingIcon !== null ? <Icon name={trailingIcon} /> : null}
    </button>
  );
});
